import { extendTheme } from '@mui/joy/styles';

// Max width of the centered page content column (TopNavigation, HouseholdLayout).
export const PAGE_MAX_WIDTH = '1600px';
export const PAGE_MAX_WIDTH_NARROW = '1600px';

// Junbee design tokens (.handoffs/design_handoff_junbee/README.md).
// primary = "cobalt", neutral = the ink/muted/border/canvas ramp.
const palette = {
  primary: {
    50: "#eef1fd",
    100: "#e8ecfb", // accent tint — active nav pill bg, TODAY badge
    200: "#c7d0f6",
    300: "#8ba0ff", // accent light — secondary accent
    400: "#6b86f3",
    500: "#2b4fd6", // cobalt — primary buttons, links, focus
    600: "#2540b0",
    700: "#1e3389",
    800: "#172763",
    900: "#101a42",
  },
  neutral: {
    50: "#ffffff",  // surface — cards, nav bar, list rows
    100: "#f7f8f9", // canvas — app background
    200: "#e9ecef", // canvas alt — inset fields e6e9ec eceef1
    300: "#e3e6e9", // border — hairlines, dividers
    400: "#d3d7dc", // border dashed — empty-slot outlines
    500: "#9aa1a8", // muted light — tertiary meta
    600: "#8a9199", // muted — meta text
    700: "#5b6269", // ink 55 — secondary text
    800: "#3c444c", // ink 70 — body text in lists
    900: "#14171a", // ink — primary text, dark surfaces
  },
};

export const theme = extendTheme({
  colorSchemes: {
    light: { palette },
    dark: { palette },
  },
  fontFamily: {
    body: "'Manrope', var(--joy-fontFamily-fallback)",
    display: "'Manrope', var(--joy-fontFamily-fallback)",
  },
  fontWeight: {
    xl: 800,
  },
  radius: {
    xs: '6px',
    sm: '8px',
    md: '10px',
    lg: '15px',
    xl: '20px',
  },
  shadow: {
    sm: '0 1px 2px rgba(20,23,26,.06)',
    md: '0 1px 3px rgba(20,23,26,.07)',        
    lg: '0 3px 6px rgba(20,23,26,.1)',
  },
  typography: {
    h2: {
      fontSize: '21px',
      fontWeight: '800',      
    },    
    'title-xs': {
      color: 'var(--joy-palette-neutral-600)',
      fontSize: '10px',
      fontFamily: "'Space Grotesk', var(--joy-fontFamily-fallback)",
      fontWeight: '500',      
      letterSpacing: '0.075em',
      textTransform: 'uppercase',
    },
    'title-sm': {
      color: 'var(--joy-palette-neutral-600)',
      fontSize: '11px',
      fontFamily: "'Space Grotesk', var(--joy-fontFamily-fallback)",
      fontWeight: '500',      
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
    'title-mdsm': {
      fontSize: '12px',
      lineHeight: '1.2',
      letterSpacing: '-0.02em',
      fontWeight: 600,
      color: 'var(--joy-palette-neutral-900)',
    },
    'title-md': {
      fontSize: '13px',
      lineHeight: '1.2',
      letterSpacing: '-0.02em',
      fontWeight: 600,
      color: 'var(--joy-palette-neutral-900)',
    },
    'title-list-item': {
      fontSize: '13.5px',
      lineHeight: '1.2',      
      fontWeight: 500,
      color: 'var(--joy-palette-neutral-900)',
    },
    'body-xs': {      
      fontWeight: 600,      
    },
  },
  components: {
    JoyDrawer: {
      styleOverrides: {
        content: {
          backgroundColor: "#fff",
        }
      }
    },
    JoyDialogTitle: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: '19px',
          fontWeight: theme.vars.fontWeight.xl,
          color: theme.vars.palette.text.primary,
          fontFamily: theme.vars.fontFamily.display,
          letterSpacing: '-0.035em',
        }),
      },      
    },
    JoyModalClose: {
      styleOverrides: {
        root: () => ({
          top: '11px',
          '--Icon-fontSize': '17px',
          '& svg': {
            stroke: 'currentColor',
            strokeWidth: 0.5,
          },
        }),
      },
    },
    JoyLinearProgress: {
      styleOverrides: {
        root: () => ({
          backgroundColor: 'var(--joy-palette-neutral-300)',          
        }),
      },
    },
    JoyCard: {
      styleOverrides: {
        root: () => ({
          border: 'none',          
          boxShadow: 'var(--joy-shadow-sm)',
        }),
      },
    }
  }
});
